/**
 * Format an ISO date (YYYY-MM-DD) as a human-readable string, e.g. "15 July 2026".
 * Parsed as UTC so a date-only string doesn't shift across timezones.
 */
export function formatDate(iso: string): string {
  const [y, m, d] = iso.split("-").map(Number);
  const date = new Date(Date.UTC(y, (m ?? 1) - 1, d ?? 1));
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
}
